import Modal from '../../components/Modals/Modal';
import WarningIcon from '../../components/Icons/outline/WarningIcon';
import { COLORS } from '../../config';
import PrimaryButton from '../../components/Buttons/PrimaryButton';



function MultipleScansCreatedModal({show, setShow, onClickConfirm}) {

  return (
      <Modal className='min-w-1/2' title={'Warning'} show={show} hide={onClickConfirm}>
        <div className='flex flex-col justify-between my-8'>
          <WarningIcon className='h-12 w-12 self-center mb-4 -mt-4' stroke={ COLORS.deleteRed } />
          <>
            <p className='mb-4 text-center'>
              <strong>Multiple studies uploaded</strong>
            </p>
            <p className='mb-4'>
              Multiple studies were detected in your upload so we have created multiples instances of the patient's scan.
            </p>
          </>
        </div>
        <div className='flex justify-end'>
          <PrimaryButton onClick={onClickConfirm} text='Continue' />
        </div>
      </Modal>
  )
}

export default MultipleScansCreatedModal
